import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';

import ExportSVG from 'Components/Admin/assets/ExportSVG.js';
import ImportSVG from 'Components/Admin/assets/ImportSVG.js';
import PlusSVG from 'Components/Admin/assets/PlusSVG.js';

import ToggleButton from 'Components/ToggleButton/ToggleButton';
import Input from 'Components/Input';
import SearchSVG from 'Components/Admin/assets/SearchSVG';

import debounce from 'lodash/debounce';
import { ADMIN_URL, SHOW_ON_DEV } from '../../../../../Admin/constants/constants';

const Dashboard = ({ searchInputValue, onlyActive, onDashboardChange }) => {
  const delayedQuery = debounce((q) => onDashboardChange(q), 500);
  const onChange = useCallback(
    (e) => {
      delayedQuery({ term: e.target.value });
    },
    [delayedQuery],
  );

  const handleIsOnlyActiveChange = (isActive) => onDashboardChange({ isActive });

  const searchInput = useMemo(() => {
    return (
      <>
        <Input
          icon={<SearchSVG />}
          className="search__input"
          initialFocusState={window.outerWidth > 1024}
          id="search__employee"
          fieldProps={{
            name: 'search',
            placeholder: 'Search',
            onChange: onChange,
            value: searchInputValue,
            onClick: (event) => event.stopPropagation(),
          }}
        />
      </>
    );
  }, [onChange, searchInputValue]);

  // TO DO: remove SHOW_ON_DEV when actions will be implemented
  return (
    <div className="dashboard">
      <div className="dashboard__left">
        <div className="only-active">
          <span>Only active</span>
          <ToggleButton
            onToggleChange={handleIsOnlyActiveChange}
            toggleStatus={onlyActive}
            inversion={true}
            extractToggle={true}
            id={'only-active'}
          />
        </div>
      </div>
      <div className="dashboard__right">
        <div className="dashboard__search">{searchInput}</div>
        {SHOW_ON_DEV && (
          <div className="dashboard__buttons">
            <button className="dashboard__buttons__control">
              <ExportSVG />
            </button>
            <button className="dashboard__buttons__control">
              <ImportSVG />
            </button>
            <Link
              exact="true"
              to={`/${ADMIN_URL}/employees/new-employee-form/`}
              className="button button_secondary button-add-employee"
            >
              Employee
              <PlusSVG />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
